import { faList } from "@fortawesome/free-solid-svg-icons/faList";
export let iconListView = faList;
export function overwriteListView(icon) {
    iconListView = icon;
}
export default iconListView;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGlzdFZpZXcuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvbGlzdFZpZXcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0EsT0FBTyxFQUFFLE1BQU0sRUFBRSxNQUFNLDBDQUEwQyxDQUFDO0FBRWxFLE1BQU0sQ0FBQyxJQUFJLFlBQVksR0FBRyxNQUFNLENBQUM7QUFFakMsTUFBTSxVQUFVLGlCQUFpQixDQUFDLElBQW9CO0lBQ3BELFlBQVksR0FBRyxJQUFJLENBQUM7QUFDdEIsQ0FBQztBQUVELGVBQWUsWUFBWSxDQUFDIn0=